import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";

const MembershipMetricFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.numberOfActiveMembersBy.membershipMetricOptions);
  const selectedMetric = useSelector(
    (state) => state.numberOfActiveMembersBy?.selectedMembershipMetric
  );

  if (Object.keys(selectedMetric).length === 0 || !selectedMetric) {
    return null;
  }

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedMetric}
      placeholder="Select Metric"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === selectedMetric.id) return;
        dispatch(actionCreators.updateMembershipMetric(data));
      }}
    />
  );
};

export default MembershipMetricFilter;
